import styled from 'styled-components';

export const ContentNotice = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TitleNotice = styled.b`
  font-size: medium;
  color: ${({ theme }) => theme.colors?.danger02};
  padding-bottom: 1rem;
`;

export const TextNotice = styled.li`
  font-size: small;
  font-weight: 500;
  padding-bottom: 0.2rem;
  color: ${({ theme }) => theme.colors?.gray05} !important;
`;
